module.exports = __webpack_public_path__ + "static/media/print.68d15131.svg";